import { lazy } from 'react';
/** Открывает форму промокода */
export const PromoCodeFormPageAsync = lazy(() => import('./PromoCodeForm/PromoCodeFormPage'));